import {FC} from 'react'

import {theme} from '@/theme/theme'

import {Icon, IconProps} from './Icon'

type ArrowIconProps = IconProps & {
  variant?: 'right' | 'left' | 'down'
}

export const ArrowIcon: FC<React.PropsWithChildren<ArrowIconProps>> = ({
  color = theme.palette.primary.main,
  size,
  variant = 'right',
}) => (
  <>
    <div className={variant}>
      <Icon size={size}>
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.0277 4.72067C10.7354 4.4284 10.2615 4.4284 9.96921 4.72067C9.67693 5.01295 9.67693 5.48683 9.96921 5.77911L13.4401 9.24989L4.75 9.24989C4.33579 9.24989 4 9.58568 4 9.99989C4 10.4141 4.33579 10.7499 4.75 10.7499L13.4401 10.7499L9.96921 14.2207C9.67693 14.513 9.67693 14.9868 9.96921 15.2791C10.2615 15.5714 10.7354 15.5714 11.0277 15.2791L15.7778 10.5291C16.0701 10.2368 16.0701 9.76295 15.7778 9.47068L11.0277 4.72067Z"
            fill={color}
          />
        </svg>
      </Icon>
    </div>

    <style jsx>{`
      .left {
        transform: rotate(-180deg);
      }
      .down {
        transform: rotate(90deg);
      }
    `}</style>
  </>
)
